import * as types from './mutations_types.js'

export const state = {
  song: [],
  popular: []
}

export const mutations = {
  [types.SET_SONG] (state, data) {
    state.song = data
    window.localStorage.setItem('song', JSON.stringify(data))
  },
  [types.SET_POPULAR] (state, data) {
    state.popular = data
    window.localStorage.setItem('popular', JSON.stringify(data))
  }
}



// WEBPACK FOOTER //
// ./src/store/song/mutations.js